const PERSIAN = "۰۱۲۳۴۵۶۷۸۹";
const ARABIC = "٠١٢٣٤٥٦٧٨٩";

export function toEnglishDigits(input: string): string {
  return input.replace(/[۰-۹٠-٩]/g, (ch) => {
    const p = PERSIAN.indexOf(ch);
    return String(p >= 0 ? p : ARABIC.indexOf(ch));
  });
}

/**
 * Normalise an Iranian mobile number to 09xxxxxxxxx, or null if it is not one.
 * Accepts Persian/Arabic digits, spaces, dashes, +98 / 0098 / 98 prefixes and
 * the leading-zero-dropped form Excel produces (9123456789).
 */
export function normalizeIrMobile(raw: unknown): string | null {
  if (raw === null || raw === undefined) return null;
  let s = toEnglishDigits(String(raw)).replace(/[\s\-().‌‎‏‪-‮]/g, "");
  if (s.startsWith("+")) s = s.slice(1);
  if (s.startsWith("0098")) s = s.slice(4);
  else if (s.startsWith("98") && s.length === 12) s = s.slice(2);
  if (/^9\d{9}$/.test(s)) s = "0" + s;
  return /^09\d{9}$/.test(s) ? s : null;
}

/** split free text (pasted list) into candidate entries */
export function splitPhoneList(text: string): string[] {
  return toEnglishDigits(text)
    .split(/[\n\r,،;\t]+|\s{2,}/)
    .map((x) => x.trim())
    .filter(Boolean)
    // "0912 345 6789" stays one number; "09121111111 09122222222" splits
    .flatMap((x) => (!normalizeIrMobile(x) && /\s/.test(x) ? x.split(/\s+/) : [x]));
}
